import type { PricingCampaignModel } from '@/shared/generated'
import type { PricingCampaignTableRow } from '../model/types'

import { getAssortmentShare } from '@/entities/pricing-campaign'

export function getPricingCampaignsTableRows(
	campaigns: PricingCampaignModel[],
	suggestedProducts: Record<string, number>,
	totalOptimizationProducts: number = 0
): PricingCampaignTableRow[] {
	return (
		campaigns?.map((campaign) => {
			const productsCount = suggestedProducts?.[campaign.id]

			return {
				campaign,
				products_count: productsCount,
				assortment_share: getAssortmentShare(
					totalOptimizationProducts,
					productsCount
				),
			}
		}) || []
	)
}
